
import { mapState } from "pinia";
import { defineComponent } from "vue";
import {
  displayCoordinates,
  formatValue,
  getCurrencySign,
  getRagIconUrl,
} from "@/util/helpers";
import { DatasetRecord } from "@/types/DatasetRecord";
import { Point } from "geojson";
import { useGammaData, useLocation, useOrgSettings } from "@/services";

export default defineComponent({
  name: "PoliciesTable",
  data: () => ({
    fields: [
      "policyRiskId",
      { key: "totalSumInsured", label: "Sum Insured" },
      { key: "formattedAddress", label: "Address" },
      "buildingId",
    ],
  }),
  computed: {
    ...mapState(useOrgSettings, ["currencySymbol"]),
    policies(): DatasetRecord[] {
      return useGammaData().visiblePolicies;
    },
  },
  methods: {
    formatValue,
    getCurrencySign,
    getRagIconUrl,
    displayCoordinates,
    iconTooltip(value: string) {
      return {
        title: value,
        animation: false,
        container: "app",
        placement: "left",
      };
    },
    setActiveEntry(record: DatasetRecord) {
      useLocation().updateLocation({
        record,
        type: record.recordType,
        geometry: record.geometry as Point,
      });
    },
  },
});
